import React from 'react'
import './Home.css'

function Home() {
  return (
    <div className=''>
      <div className="profile-container">
        <div className="cover">
          <div>
            <h1>Let’s make your product a success</h1>
            <p>
              Crator is your partner in digital innovation. We fuse strategic <br /> thinking with standout design and development to deliver <br /> uniquely tailored solutions.
            </p>
            <div className="buttons">
              <a href="" className='btn x-btn'>Let's get started</a>
              <a href="" className='btn2 x-btn'>Let's get started</a>
            </div>
          </div>

          <img src="https://crator.tailwindawesome.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fhero-home.88f6cc60.jpg&w=640&q=75" alt="" className="user-pro" />
        </div>

        <div className="partners">
          <div className="partner-text">
            <div className="text">
              <span><b>Our Partners:</b></span>
              <h1>Trusted by the best companies <br /> in the business</h1>
              <p>
                Collaborating with various sectors, we’ve helped startups and established <br /> businesses alike to flourish.
              </p>
            </div>

            <div className="partner-card">
              <div className="cards">
                <p>Upwork</p>
              </div>
              <div className="cards">
                <i class="fab fa-shopify"></i> <p>Shopify</p>
              </div>

              <div className="cards">
                <i class="fab fa-cc-amazon-pay"></i> <br /> <p>Amazon</p>
              </div>

              <div className="cards">
                <p>Adope</p>
              </div>

              <div className="cards">
                <p>Snap Inc.</p>
              </div>

              <div className="cards">
                <p>STRAVA.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="what-we-dos profile-container ">

        <div className="dos-card">
          <span className='btm-color'><b>What we do:</b></span>
          <div className="do-text">
            <div>
              <h1>
                We create digital products <br /> that help you get ahead
              </h1>
            </div>
            <div>
              <p>
                From fresh ideas to fully-realized designs, we cover <br /> every aspect of your digital presence.
              </p>
            </div>
          </div>
        </div>

        <div className="card-text-components">
          <div className="card-txt">

            <div className="crt">
              <div className="isons">
                <i class="fab fa-app-store-ios"></i>
              </div>
              <div className="text-infor">
                <h3>Web Design</h3>
                <p>
                  We craft visually stunning, unforgettabl <br />e experiences with responsive design at the <br /> forefront.
                </p>
              </div>
            </div>
            {/*  */}
            <div className="crt">
              <div className="isons">
                <i class="fab fa-app-store-ios"></i>
              </div>
              <div className="text-infor">
              <h3>Web Development</h3>
                <p>
                    We excell at converting eye-catching designs <br /> into high-functioning, user-friendly web <br /> applications.
                  </p>
              </div>
            </div>
            {/*  */}
            <div className="crt">
              <div className="isons">
                <i class="fab fa-app-store-ios"></i>
              </div>
              <div className="text-infor">
              <h3>Maintenance & Optimization</h3>
              <p>
                    We ensure your site remains an effective, <br /> optimized tool for your business needs, goals <br /> and growth.
                  </p>
              </div>
            </div>
            {/*  */}
          </div>
          <div className="cardimg">
            <img className='pxc' src="https://crator.tailwindawesome.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fwhat-we-do-image-01.a9e0cd5f.jpg&w=360&q=75" alt="" />
            <div>
              <img src="https://crator.tailwindawesome.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fwhat-we-do-image-02.ce7f0c18.jpg&w=360&q=75" alt="" />
              <img src="https://crator.tailwindawesome.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fwhat-we-do-image-03.717cbe58.jpg&w=360&q=75" alt="" />
            </div>
          </div>
        </div>
      </div>


      <div className="our-process">
        <div className="our-process-div">
          <span><b>Our Partners:</b></span>
          <h1>Experience our simple design <br /> process</h1>
          <p>
          Uncover the essence of your brand, through our highly collaborative and <br /> intuitively structured design process.
          </p>

          <div className="card-data">
            <div className="data">
              <div>
              <i class="fas fa-scroll"></i>
              </div>
              <h2>1.Collect Ideas</h2>
              <p>
              We gather comprehensive insights about <br /> your product to fully understand your <br /> unique needs and vision.
              </p>
            </div>

            <div className="data">
              <div>
              <i class="fab fa-slack-hash"></i>
              </div>
              <h2>2. Design Concept</h2>
              <p>
              We creatively dHctdHJhbnNmb3Jt your <br /> vision and ideas into design drafts. We <br />iterate until you are satisfied.
              </p>
            </div>

            <div className="data">
              <div>
              <i class="fas fa-rocket"></i>
              </div>
              <h2>3. Finalize Product</h2>
              <p>
              Upon your approval, we finalize and refine <br /> the design and launch your uniquely <br />tailored product to the market.
              </p>
            </div>
          </div>
        </div>
      </div>


      {/* <div class="profile-container">
        <div class="our-work">
          <span><b>Our work:</b></span>
          <h1>Check out some of our recent & <br /> current work</h1>
        </div>

        <div class="card-container">

          <div class="card">
            <img src="https://crator.tailwindawesome.com/_next/image?url=%2Fstock%2Fwork%2Ffeatured-work-image-01.jpg&w=1200&q=75" alt="" />
          </div>


          <div class="card">
            <img src="Your-Image-URL-Here.jpg" alt="" />
          </div>
        </div>
      </div> */}

<div class="profile-container-work">
  <div class="our-work">
    <span><b>Our work:</b></span>
    <h1>Check out some of our recent & <br /> current work</h1>
  </div>

  <div class="card-container">
    {/* <!-- Main Card (.card-img-card) --> */}
    <div class="card-img-card">
      {/* <img src="https://crator.tailwindawesome.com/_next/image?url=%2Fstock%2Fwork%2Ffeatured-work-image-01.jpg&w=1200&q=75" alt="" /> */}
    </div>

    {/* <!-- Smaller Card (.nedia-card) --> */}
    <div class="nedia-card">
      <div className="infor-cc">
        <h1>Sastastic</h1>
        <p>
        Mauris blandit aliquet elit, eget <br /> tincidunt nibh pulvinar a. Vivamus magna <br /> justo, lacinia eget sed, convallis at tellus.
        </p>
      </div>
    </div>
  </div>
</div>

<section>
  <div className="container">
    <div className="left"></div>
    <div className="right"></div>
  </div>
</section>


    </div>
  )
}

export default Home